import { useEffect } from "react"
import GroupMenuForm from "./GroupMenuForm"

const GroupMenu = ({ open }) => {
    useEffect(() => {
        document.title = 'Group Menu Access'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <GroupMenuForm />
        </main>
    )
}
export default GroupMenu